import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "module-switch-container" }
const _hoisted_2 = { class: "breeze-brand-wrapper" }
const _hoisted_3 = { class: "brand-text-box" }
const _hoisted_4 = { class: "brand-title" }
const _hoisted_5 = { class: "brand-subtitle" }

import { computed, markRaw, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import {
  User,
  Bicycle,
  Position,
  Ticket,
} from '@element-plus/icons-vue'
import { routeNames } from '@/router/route-names'
import { LsGlobalKeys, lsGet } from '@/helpers/local-storage'
import { useAuthStore } from '@/store/auth'
import { getGolfReserves } from '@/api/golf'
import {
  hasEvAccess as checkEvAccess,
  hasGolfAccess as checkGolfAccess,
  hasP2pAccess as checkP2pAccess,
} from '@/helpers/rbac'

interface Props {
  collapse: boolean
  showGolfModule?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GolfMenu',
  props: {
    collapse: { type: Boolean },
    showGolfModule: { type: Boolean }
  },
  emits: ["switchModule"],
  setup(__props: any) {





const router = useRouter()
const authStore = useAuthStore()

const signOut = async () => {
  await authStore.signOut()
  router.push({ name: routeNames.login })
}

const hasP2pAccess = computed(() => checkP2pAccess(authStore.session?.user))
const hasEvAccess = computed(() => checkEvAccess(authStore.session?.user))
const hasGolfAccess = computed(() => checkGolfAccess(authStore.session?.user))

const activeReservesCount = ref(0)

const loadActiveReservesCount = async () => {
  try {
    const response = await getGolfReserves()
    const responseData = response.data?.data as any
    const items = responseData?.data || []
    activeReservesCount.value = Array.isArray(items) ? items.length : 0
  } catch (error) {
    console.error('Failed to load active reserves count:', error)
  }
}

const currentModule = computed(() => {
  const raw = lsGet(LsGlobalKeys.CURRENT_MODULE)
  let saved: string | null = null
  if (raw) {
    try { saved = JSON.parse(raw) } catch { saved = raw }
  }
  return saved === 'ev' || saved === 'golf' ? saved : 'p2p'
})

const currentModuleIcon = computed(() => {
  const icons: Record<string, any> = {
    p2p: markRaw(User),
    ev: markRaw(Bicycle),
  }
  return icons[currentModule.value] || markRaw(User)
})

const navigate = (routeName?: string) => {
  if (routeName) router.push({ name: routeName })
}

const activeMenuIndex = computed(() => {
  const currentRouteName = router.currentRoute.value.name as string
  const routeToIndexMap: Record<string, string> = {
    [routeNames.golfDashboard]: 'golf-dashboard',
    [routeNames.golfCars]: 'golf-cars',
    [routeNames.golfMapAreas]: 'map-areas',
    [routeNames.golfReserves]: 'golf-reserves',
    [routeNames.golfTrips]: 'golf-trips',
    [routeNames.golfUsers]: 'golf-users',
    [routeNames.golfSettings]: 'golf-settings',
    [routeNames.golfFinancialReport]: 'golf-financial-report',
    [routeNames.golfTariffSettings]: 'golf-tariff-settings',
    [routeNames.golfAdminRoles]: 'golf-admin-roles',
  }
  return routeToIndexMap[currentRouteName] || ''
})

onMounted(() => {
  loadActiveReservesCount()
})

return (_ctx: any,_cache: any) => {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "unique-opened": false,
    collapse: _ctx.collapse,
    "collapse-transition": false,
    mode: "vertical",
    "default-active": activeMenuIndex.value,
    class: "el-menu-vertical golf-menu"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_dropdown, {
          onCommand: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('switchModule', $event))),
          trigger: "click"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                (hasP2pAccess.value)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 0,
                      command: "p2p"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.menu.switch_p2p')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (hasEvAccess.value)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 1,
                      command: "ev"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.menu.switch_ev')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (hasGolfAccess.value && _ctx.showGolfModule)
                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                      key: 2,
                      command: "golf"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('golf.menu.switch_golf')), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[9] || (_cache[9] = _createElementVNode("div", {
                class: "brand-icon-box",
                style: {"background-color":"#FCA82D","width":"40px","height":"40px","border-radius":"4px","display":"flex","align-items":"center","justify-content":"center"}
              }, [
                _createElementVNode("img", {
                  src: "/icons_golf_module/Logo Breeze Golf.svg",
                  alt: "Breeze Golf",
                  style: {"width":"24px","height":"24px"}
                })
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('golf.menu.brand')), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('golf.menu.brand_subtitle')), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_menu_item, {
        index: "golf-dashboard",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate(_unref(routeNames).golfDashboard)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.dashboard')), 1)
        ]),
        default: _withCtx(() => [
          _cache[10] || (_cache[10] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Dashboard.svg')","mask-image":"url('/icons_golf_module/Dashboard.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [10]
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-trips",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (navigate(_unref(routeNames).golfTrips)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.trips')), 1)
        ]),
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Trips.svg')","mask-image":"url('/icons_golf_module/Trips.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [11]
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-cars",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (navigate(_unref(routeNames).golfCars)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.fleet')), 1)
        ]),
        default: _withCtx(() => [
          _cache[12] || (_cache[12] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Fleet Managment.svg')","mask-image":"url('/icons_golf_module/Fleet Managment.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [12]
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-tariff-settings",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (navigate(_unref(routeNames).golfTariffSettings)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.tariffs_settings')), 1)
        ]),
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Tariff & Settings.svg')","mask-image":"url('/icons_golf_module/Tariff & Settings.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [13]
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-financial-report",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (navigate(_unref(routeNames).golfFinancialReport)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.financial_reports')), 1)
        ]),
        default: _withCtx(() => [
          _cache[14] || (_cache[14] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Financial Reports & Billing.svg')","mask-image":"url('/icons_golf_module/Financial Reports & Billing.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [14]
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-admin-roles",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (navigate(_unref(routeNames).golfAdminRoles)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.menu.user_role')), 1)
        ]),
        default: _withCtx(() => [
          _cache[15] || (_cache[15] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/User Role.svg')","mask-image":"url('/icons_golf_module/User Role.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [15]
      }),
      _createVNode(_component_el_menu_item, {
        index: "map-areas",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (navigate(_unref(routeNames).golfMapAreas)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.fleet.resort_deployment_zone')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Position))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_menu_item, {
        index: "golf-settings",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (navigate(_unref(routeNames).golfSettings)))
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.promo.promo_codes')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Ticket))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "menu-spacer" }, null, -1)),
      _createVNode(_component_el_menu_item, {
        class: "signout-menu-item",
        onClick: signOut
      }, {
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('golf.header.sign_out')), 1)
        ]),
        default: _withCtx(() => [
          _cache[16] || (_cache[16] = _createElementVNode("i", {
            class: "menu-icon",
            style: {"-webkit-mask-image":"url('/icons_golf_module/Sign Out.svg')","mask-image":"url('/icons_golf_module/Sign Out.svg')"}
          }, null, -1))
        ]),
        _: 1,
        __: [16]
      })
    ]),
    _: 1,
    __: [17]
  }, 8, ["collapse", "default-active"]))
}
}

})